import React from 'react';

const Dashboard = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">HRIS Dashboard</h2>
      <p>Welcome to the Human Resources Information System Dashboard.</p>
    </div>
  );
};

export default Dashboard;
